import { Euler as t, MathUtils as n, Vector3 as i } from "three";
import { DegToRadV3 as m } from "../geometry-utils/three/index5.js";
import { EulerToSignedAngle as f } from "./index9.js";
const r = new t();
function p(o, e = new i(0, 1, 0)) {
  return r.fromArray(m(o)), f(r, e) * n.RAD2DEG;
}
export {
  p as rotToSignedAngle
};
//# sourceMappingURL=index30.js.map
